import { getPagination } from '@/utils/helpers';
import {
    FETCH_DOCTOR_CUSTOMERS
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        /**
         * Danh sách KH (load mới)
         */
        case FETCH_DOCTOR_CUSTOMERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        default:
            return state;
    }
};
